import * as ss from 'superstruct';
import { MetaAdAccountId } from '../../tracking/ad-account-id';

/**
 * The configuration for sending conversions to Meta. Used for sending

 * Also used by analytics to report on stats.
 */
export const MetaAdsOutputStreamDestination = ss.type({
  name: ss.literal('meta-ads'),
  /** The Meta Access token. Generated per pixel. Write-only: masked on read. */
  accessToken: ss.string(),
  /** The Meta pixel ID for the organization. */
  pixelId: ss.string(),
  /** Event name to post in  */
  eventName: ss.string(),
  /** Meta ad account ID. Stored as digits, without the `act_` prefix. */
  accountId: MetaAdAccountId,
});

export type MetaAdsOutputStreamDestination = ss.Infer<
  typeof MetaAdsOutputStreamDestination
>;
